export default __webpack_public_path__ + "static/media/sandal9.108fe74e.jpeg";